import React from 'react';
import { IValueCell } from './interfaces';
import { Box, Typography } from '@mui/material';

export const ValueCell: React.FC<IValueCell> = ({
  value,
  children,
  sx,
  alignItems = 'center',
}): JSX.Element => {
  return (
    <Box
      sx={{ display: 'flex', alignItems: alignItems, height: '100%', ...sx }}
    >
      {!children && <Typography variant="body2">{value || '-'}</Typography>}
      {children}
    </Box>
  );
};
